<template>
  <div class="proDetails">
    <div class="fw" v-for="(item,index) in infoData" v-html="item.ProductDesc"></div>
  </div>
</template>

<script>
export default {
 name: "proDetails",
  data(){
    return{
      infoData:[]
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id)
  },
  methods:{
    //获取产品详情
    getInfo(id){
      let data = {params:{Id:id}};
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntProductIdSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data
      })
    }
  }


}
</script>

<style >
.esmartMargin {
  left: 0 !important;
  right: 0 !important;
  margin: 50px auto !important;
  overflow: hidden !important;
  position:static !important;
}
</style>